import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { cn } from "@/utils/cn";
import { getSafeAreaBottom } from "@/utils/safe-area-bottom";
import { DislikeMealButton } from "../dislike-meal-button";
import { LikeMealButton } from "../like-meal-button";
import { SkipMealButton } from "../skip-meal-button";
import { SwapPlanConfirmButton } from "../swap-plan-confirm-button";
import { CalorieDifferenceLabel } from "../calorie-difference-label";
import { MealTitleWithDetail } from "./meal-title-with-detail";

interface SwapPlanMealDetailsCardProps {
  meal: Meal;
  mealTime: MealTime;
  mealDay: string;
  targetDate?: string;
  mealIndex?: number;
  currentMealId?: string;
  requestId?: string | null;
  /** Position/index of this meal in the alternatives list */
  selectedPosition?: number;
  className?: string;
  onSkipToNext: () => void;
  isExtra?: boolean;
}

export const SwapPlanMealDetailsCard = ({
  meal,
  mealTime,
  mealDay,
  targetDate,
  mealIndex,
  currentMealId,
  requestId,
  selectedPosition,
  className,
  onSkipToNext,
  isExtra,
}: SwapPlanMealDetailsCardProps) => {
  return (
    <div
      className={cn(
        "flex h-[176px] w-full flex-col items-center justify-between px-7.5",
        className,
      )}
      style={{ paddingBottom: getSafeAreaBottom() }}
    >
      <MealTitleWithDetail
        meal={meal}
        mealTime={mealTime}
        mealDay={mealDay}
        targetDate={targetDate}
        mealIndex={mealIndex}
      />

      <div className="flex flex-col items-center justify-center gap-6">
        <div className="flex items-center justify-around gap-8.5">
          <DislikeMealButton
            meal={meal}
            requestId={requestId}
            ariaLabel="Dislike this meal"
            onDislike={onSkipToNext}
            className="h-11 w-11"
          />

          <SkipMealButton onSkip={onSkipToNext} />

          <SwapPlanConfirmButton
            meal={meal}
            mealTime={mealTime}
            mealDay={mealDay}
            targetDate={targetDate}
            mealIndex={mealIndex}
            currentMealId={currentMealId}
            requestId={requestId}
            selectedPosition={selectedPosition}
            isExtra={isExtra}
          />

          <LikeMealButton
            meal={meal}
            mealTime={mealTime}
            requestId={requestId}
            ariaLabel="Like this meal"
            className="h-11 w-11"
          />
        </div>

        <CalorieDifferenceLabel value={meal.calorieDifference} />
      </div>
    </div>
  );
};
